// extracted by mini-css-extract-plugin
export var containerWrapper = "ComponentWrapper-module--containerWrapper--c7a78";
export var fullWidth = "ComponentWrapper-module--fullWidth--413b9";
export var pearl = "ComponentWrapper-module--pearl--ce665";
export var royal = "ComponentWrapper-module--royal--c44b8";
export var sectionHeading = "ComponentWrapper-module--sectionHeading--f3898";
export var sun = "ComponentWrapper-module--sun--a95f3";
export var tide = "ComponentWrapper-module--tide--f805e";
export var wedding = "ComponentWrapper-module--wedding--2b395";